<template>
	<div class="modal__container-links">
		<a
			class="share__page__link"
			style="margin-right: 10px"
			:href="socialUrls.twitter"
			target="_blank"
			title="Share via Twitter"
			@click="shareBet('twitter')"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="30px"
				viewBox="0 0 20 20"
				fill="none"
			>
				<path
					d="M15.2716 1.58655H18.0828L11.9411 8.60612L19.1663 18.1582H13.509L9.07804 12.3649L4.00796 18.1582H1.19503L7.7642 10.65L0.833008 1.58655H6.63393L10.6392 6.88182L15.2716 1.58655ZM14.2849 16.4755H15.8427L5.7875 3.18082H4.11589L14.2849 16.4755Z"
					fill="var(--light-black)"
				/>
			</svg>
		</a>

		<a
			class="share__page__link"
			style="margin-right: 10px"
			:href="socialUrls.facebook"
			target="_blank"
			title="Share via Facebook"
			@click="shareBet('facebook')"
		>
			<svg
				width="30px"
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 408.788 408.788"
				style="enable-background: new 0 0 408.788 408.788"
				xml:space="preserve"
			>
				<path
					style="fill: #475993"
					d="M353.701,0H55.087C24.665,0,0.002,24.662,0.002,55.085v298.616c0,30.423,24.662,55.085,55.085,55.085
                h147.275l0.251-146.078h-37.951c-4.932,0-8.935-3.988-8.954-8.92l-0.182-47.087c-0.019-4.959,3.996-8.989,8.955-8.989h37.882
                v-45.498c0-52.8,32.247-81.55,79.348-81.55h38.65c4.945,0,8.955,4.009,8.955,8.955v39.704c0,4.944-4.007,8.952-8.95,8.955
                l-23.719,0.011c-25.615,0-30.575,12.172-30.575,30.035v39.389h56.285c5.363,0,9.524,4.683,8.892,10.009l-5.581,47.087
                c-0.534,4.506-4.355,7.901-8.892,7.901h-50.453l-0.251,146.078h87.631c30.422,0,55.084-24.662,55.084-55.084V55.085
                C408.786,24.662,384.124,0,353.701,0z"
				/>
			</svg>
		</a>

		<a
			class="share__page__link"
			style="margin-right: 10px"
			:href="socialUrls.whatsapp"
			target="_blank"
			title="Share via Whatsapp"
			@click="shareBet('whatsapp')"
		>
			<svg
				width="30px"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 512 512"
				style="enable-background: new 0 0 512 512"
				xml:space="preserve"
			>
				<path
					style="fill: #ededed"
					d="M0,512l35.31-128C12.359,344.276,0,300.138,0,254.234C0,114.759,114.759,0,255.117,0
                S512,114.759,512,254.234S395.476,512,255.117,512c-44.138,0-86.51-14.124-124.469-35.31L0,512z"
				></path>
				<path
					style="fill: #55cd6c"
					d="M137.71,430.786l7.945,4.414c32.662,20.303,70.621,32.662,110.345,32.662
                c115.641,0,211.862-96.221,211.862-213.628S371.641,44.138,255.117,44.138S44.138,137.71,44.138,254.234
                c0,40.607,11.476,80.331,32.662,113.876l5.297,7.945l-20.303,74.152L137.71,430.786z"
				></path>
				<path
					style="fill: #fefefe"
					d="M187.145,135.945l-16.772-0.883c-5.297,0-10.593,1.766-14.124,5.297
                c-7.945,7.062-21.186,20.303-24.717,37.959c-6.179,26.483,3.531,58.262,26.483,90.041s67.09,82.979,144.772,105.048
                c24.717,7.062,44.138,2.648,60.028-7.062c12.359-7.945,20.303-20.303,22.952-33.545l2.648-12.359
                c0.883-3.531-0.883-7.945-4.414-9.71l-55.614-25.6c-3.531-1.766-7.945-0.883-10.593,2.648l-22.069,28.248
                c-1.766,1.766-4.414,2.648-7.062,1.766c-15.007-5.297-65.324-26.483-92.69-79.448c-0.883-2.648-0.883-5.297,0.883-7.062
                l21.186-23.834c1.766-2.648,2.648-6.179,1.766-8.828l-25.6-57.379C193.324,138.593,190.676,135.945,187.145,135.945"
				></path>
			</svg>
		</a>
		<a
			class="share__page__link"
			:href="socialUrls.telegram"
			target="_blank"
			@click="shareBet('telegram')"
		>
			<svg
				width="30px"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 512 512"
				style="enable-background: new 0 0 512 512"
				xml:space="preserve"
			>
				<circle
					style="fill: #41b4e6"
					cx="255.997"
					cy="256"
					r="255.997"
				></circle>
				<path
					style="fill: #0091c8"
					d="M512,256.003c0-6.238-0.235-12.419-0.673-18.546L405.228,131.36L106.772,248.759l114.191,114.192
	l1.498,5.392l1.939-1.955l0.008,0.008l-1.947,1.947L348.778,494.66C444.298,457.5,512,364.663,512,256.003z"
				></path>
				<polygon
					style="fill: #ffffff"
					points="231.138,293.3 346.829,380.647 405.228,131.36 106.771,248.759 197.588,278.84 
	363.331,167.664 "
				></polygon>
				<polygon
					style="fill: #d2d2d7"
					points="197.588,278.84 222.461,368.344 231.138,293.3 363.331,167.664 "
				></polygon>
				<polygon
					style="fill: #b9b9be"
					points="268.738,321.688 222.461,368.344 231.138,293.3 "
				></polygon>
			</svg>
		</a>
	</div>
</template>

<script>
export default {
	name: "SocialLinks",
	props: {
		socialUrls: {
			type: Object,
			default: () => {},
		},
		trackingSource: {
			type: String,
			required: false,
			default: "betShare",
		},
	},
	data() {
		return {
			platform: null,
		};
	},
	methods: {
		shareBet(socialText) {
			let vm = this;

			if (socialText.toLowerCase() === "facebook") {
				vm.platform = "FB";
			} else if (socialText.toLowerCase() === "twitter") {
				vm.platform = "TW";
			} else if (socialText.toLowerCase() === "whatsapp") {
				vm.platform = "WA";
			} else if (socialText.toLowerCase() === "telegram") {
				vm.platform = "TG";
			} else if (socialText.toLowerCase() === "sms") {
				vm.platform = "SMS";
			} else {
				vm.platforms = "";
			}

			if (vm.trackingSource === "betShare") {
				this.analyticsTrack("general", "shareABet", {
					platform: vm.platform,
				});
			}
			// To add a new analytics for social link sharing, make sure you pass the trackingSource prop name
			// else if (vm.trackingSource === "affiliates") {
			// }
		},
	},
};
</script>

<style></style>
